var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container load-plan" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-position": "top",
            "label-width": "8em",
            inline: true,
            size: "mini",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "w-100",
                      attrs: { label: _vm.$t("dateRange.dateRange") },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: false,
                          "start-placeholder": _vm.$t("dateRange.startDate"),
                          "end-placeholder": _vm.$t("dateRange.endDate"),
                          "picker-options": { firstDayOfWeek: 7 },
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "w-100",
                      attrs: { label: _vm.$t("planning.columns.projectCode") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { size: "mini", filterable: "", multiple: "" },
                          model: {
                            value: _vm.selectedProjectCodes,
                            callback: function ($$v) {
                              _vm.selectedProjectCodes = $$v
                            },
                            expression: "selectedProjectCodes",
                          },
                        },
                        _vm._l(_vm.$projectCodes, function (item) {
                          return _c("el-option", {
                            key: item.RecId,
                            attrs: {
                              label: item.ProjectCode,
                              value: item.ProjectCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "padding-top-28" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("data")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "search",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.search"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "padding-top-28" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getData("xls")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: "file-excel",
                              "aria-hidden": "true",
                              size: "sm",
                            },
                          }),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("general.downloadExcel"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "load-plan" },
            [
              _c(
                "el-table",
                {
                  ref: "loadPlanTable",
                  staticClass: "mt-3",
                  attrs: {
                    size: "mini",
                    border: "",
                    stripe: "",
                    data: _vm.reportData,
                  },
                  on: { "row-click": _vm.handleRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "50" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.date"), prop: "code" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("truck.planId"), prop: "planId" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("planning.columns.status") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getPlanStatus(scope.row.routes)
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("truck.truckPlateNum"),
                      prop: "plateNumber",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.columns.projectCode"),
                      "class-name": "evan",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.helper
                                          .uniq(
                                            _vm.helper.flatten(
                                              scope.row.routes.map(function (
                                                route
                                              ) {
                                                return route.projectCode
                                              })
                                            )
                                          )
                                          .join(", ")
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.shipRefs"),
                      "class-name": "evan",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.helper
                                          .uniq(
                                            _vm.helper.flatten(
                                              scope.row.routes.map(function (
                                                route
                                              ) {
                                                return route.shipmentReference
                                              })
                                            )
                                          )
                                          .join(", ")
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.gw"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        parseFloat(
                                          _vm.helper.sumBy(
                                            scope.row.routes,
                                            function (route) {
                                              return route.capacity1 || 0
                                            }
                                          )
                                        ).toFixed(5) + " KG"
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("planning.tooltip.cbm"),
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.routes.length > 0
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        parseFloat(
                                          _vm.helper.sumBy(
                                            scope.row.routes,
                                            function (route) {
                                              return route.capacity2 || 0
                                            }
                                          )
                                        ).toFixed(5)
                                      ) +
                                      " "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-table",
                                {
                                  staticClass: "m-3",
                                  staticStyle: { width: "calc(100% - 32px)" },
                                  attrs: {
                                    size: "mini",
                                    border: "",
                                    stripe: "",
                                    data: scope.row.routes,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { type: "index" },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.columns.status"),
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "jobOrder.status." +
                                                        prop.row.status
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("zone.selectCode"),
                                      prop: "zone",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("zone.selectProject"),
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return prop.row.projectCode &&
                                              prop.row.projectCode.length > 0
                                              ? [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        prop.row.projectCode.join(
                                                          ", "
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              : undefined
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t(
                                        "planning.columns.shipmentReference"
                                      ),
                                      width: "120",
                                      "class-name": "evan",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return prop.row.shipmentReference &&
                                              prop.row.shipmentReference
                                                .length > 0
                                              ? [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        prop.row.shipmentReference.join(
                                                          ", "
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              : undefined
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.gMap.district"),
                                      prop: "district",
                                      width: "100",
                                      "class-name": "evan",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.address"),
                                      prop: "displayAddress",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.gw"),
                                      width: "85",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (prop) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    parseFloat(
                                                      prop.row.capacity1
                                                    ).toFixed(5) + " KG"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.cbm"),
                                      prop: "capacity2",
                                      width: "80",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.start"),
                                      prop: "startTime",
                                      width: "140",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("planning.tooltip.endTime"),
                                      prop: "endTime",
                                      width: "140",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3576286329
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }